import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationServiceDelete = {
    path: "/template/service",
    method: ERouteHttpVerb.DELETE
};
export { routeLocationServiceDelete };
